


















































import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'


@Component({
  computed: {
    ...mapState({
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout,
    })
  }
})
export default class Footer extends Vue {
  $smallScreen!: boolean
  icons: string[] = [
    'mdi-home',
    'mdi-email',
    'mdi-calendar',
    'mdi-delete',
  ]
  items: string[] = [
    'default',
    'absolute',
    'fixed',
  ]
  padless: boolean = false
  variant: string = 'default'
  pageLayout!: string

  get lightFooter () {
    return this.pageLayout === 'layout2'
  }

  get imgHeight () {
    return this.$smallScreen ? '25px' : '40px'
  }
  get localAttrs () {
    const attrs: any = {}

    if (this.variant === 'default') {
      attrs.absolute = false
      attrs.fixed = false
    } else {
      attrs[this.variant] = true
    }
    return attrs
  }
}
